import * as actionTypes from "../actionTypes";

export function setBosUser(bosUser) {
  return { type: actionTypes.SET_BOSUSER, data: bosUser };
}

export function clearBosUser() {
  return { type: actionTypes.CLEAR_BOSUSER };
}
